
class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    this.init();
    this.intervalId = null;
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  init() {
    const messageEl = this.querySelector('#next-day-delivery-message');
    if (!messageEl) return;

    const cutoffHour = parseInt(this.dataset.cutoff || '14', 10);

    let deliveryDayIndexes = [];
    let excludedDates = [];

    try {
      deliveryDayIndexes = JSON.parse(this.dataset.deliveryDays || '[]').map(d => parseInt(d, 10));
      excludedDates = JSON.parse(this.dataset.excludedDates || '[]');
    } catch (e) {
      console.error('Failed to parse delivery data:', e);
      messageEl.textContent = '';
      return;
    }

    function getNextDeliveryDate() {
      const now = new Date();
      const maxDays = 14;

      for (let i = 1; i <= maxDays; i++) {
        const todaysDate = new Date(now);
        todaysDate.setDate(now.getDate() + i);

        const dayIndex = todaysDate.getDay();
        const dateStr = todaysDate.toISOString().split('T')[0];

        if (deliveryDayIndexes.includes(dayIndex) && !excludedDates.includes(dateStr)) {
          return { date: todaysDate, daysAhead: i };
        }
      }
      return null;
    }

    function updateCountdown() {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(cutoffHour, 0, 0, 0);

      const delivery = getNextDeliveryDate();

      if (!delivery) {
        messageEl.textContent = theme.translations.not_available_message;
        return;
      }

      const options = { weekday: 'long', month: 'long', day: 'numeric' };
      const formattedDate = delivery.date.toLocaleDateString(undefined, options);

      if (delivery.daysAhead === 1 && now < cutoff) {

        const diff = cutoff.getTime() - now.getTime();
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const formattedTime = `${hours}h ${minutes.toString().padStart(2, '0')}m`

        messageEl.textContent = theme.translations.delivery_message.replace('{{ time }}', formattedTime)
      } else {
        messageEl.textContent = theme.translations.next_available_message.replace('{{ time }}', formattedDate);
      }
    }

    updateCountdown();
    this.intervalId = setInterval(updateCountdown, 60000);
  }
}

customElements.define('delivery-countdown', DeliveryCountdown);

document.addEventListener("cart:update", function () {
  setTimeout(() => {
    const countdownElements = document.querySelectorAll('delivery-countdown');
    countdownElements.forEach(element => {
      const newElement = document.createElement('delivery-countdown');
      newElement.innerHTML = element.innerHTML;
      newElement.dataset.cutoff = element.dataset.cutoff;
      newElement.dataset.deliveryDays = element.dataset.deliveryDays;
      newElement.dataset.excludedDates = element.dataset.excludedDates;

      element.replaceWith(newElement);
    });
  }, 100);
});